export const decoration = {
  'with-box-shadow-light': {
    boxShadow: "1px 2px 6px rgba(0,0,0,0.10)",
  },
  'with-box-shadow': {
    boxShadow: "1px 2px 6px rgba(0,0,0,0.15)",
  },
  'with-hover': {
    border: "1px solid",
    borderColor: "transparent",
    transition: "0.2s all ease",
    bgColor: "white",
    _hover: {
      borderColor: "brand.500",
      bgColor: "brand.50",
      color: "text.500"
    }
  },
  "with-clickable": {
    _hover: {
      cursor: "pointer",
    }
  },
  'with-selected': {
    border: "1px solid",
    transition: "0.2s all ease",
    borderColor: "brand.500",
    bgColor: "brand.50",
    cursor: "pointer"
  }
}
